/* src/app/components/grids/fileuploadhistorygrid/fileuploadhistorygrid.component.css */
tr:nth-child(even) {
  background-color: #f2f2f2;
}
.e-headercontent {
  border-right-width: 0 !important;
}
.import-log {
  border-right: solid 1px #dddddd !important;
}
.e-control.e-dialog {
  margin-left: 50px;
}
.e-dlg-header-content {
  background-color: #0071bb;
  height: 30px;
  padding-bottom: 30px;
  padding-top: 10px;
  text-align: center;
}
.e-dlg-header {
  font-size: 17px;
  color: #fff;
}
[data-title]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}
[data-title]:after {
  content: attr(data-title);
  position: absolute;
  bottom: -1.6em;
  left: 100%;
  padding: 4px 4px 4px 8px;
  color: #222;
  white-space: nowrap;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-box-shadow: 0px 0px 4px #222;
  -webkit-box-shadow: 0px 0px 4px #222;
  box-shadow: 0px 0px 4px #222;
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
}
[data-title] {
  position: relative;
}
/*# sourceMappingURL=fileuploadhistorygrid.component.css.map */
